import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AngularFireStorage } from 'angularfire2/storage';
import { AuthProvider } from '../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-program-docs-secure',
  templateUrl: 'program-docs-secure.html',
})
export class ProgramDocsSecurePage {

  program_id: string;
  program_name: string;
  user: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private afs: AngularFireStorage,
  ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

      const ref = this.afs.storage.ref('/secureuploads');

    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramDocsSecurePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-docs-secure/program-docs-secure.ts